/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_RenameInputs */

const zh_course_rename = /** @type {(inputs: Course_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重命名`)
};

const en_course_rename = /** @type {(inputs: Course_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

const es_course_rename = /** @type {(inputs: Course_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrar`)
};

/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Course_RenameInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_rename = /** @type {((inputs?: Course_RenameInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_RenameInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_rename(inputs)
	if (locale === "en") return en_course_rename(inputs)
	return es_course_rename(inputs)
});